export class LogsSchema {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appName",
            "baseName": "appName",
            "type": "string",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaName",
            "baseName": "schemaName",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<LogsSchemaColumn>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogsSchema.attributeTypeMap;
    }
    constructor() {
    }
}
